<template>
  <div class="win-or-lost">
    <div class="description">
      Select whether this Quote was Won or Lost. If Won, please provide any
      additional details such as priors, assigned appraiser, intended use or
      other details that would help the Admin team process the Award. Note:
      For Job Setup use the New Job Setup option.
    </div>

    <div class="lookup-link">
      <a href="#" @click.prevent="handleLookup">
        <i class="ms-Icon ms-Icon--Search"></i>
        Look up active quotes or assignments
      </a>
    </div>

    <div class="status-section">
      <h3>Status</h3>
      <div class="status-buttons">
        <button 
          :class="['status-btn', { active: status === 'win' }]"
          @click="setStatus('win')"
        >
          <i class="ms-Icon ms-Icon--ThumbsUp"></i>
          Win
        </button>
        <button 
          :class="['status-btn', { active: status === 'loss' }]"
          @click="setStatus('loss')"
        >
          <i class="ms-Icon ms-Icon--ThumbsDown"></i>
          Loss
        </button>
      </div>
    </div>

    <div class="comments-section">
      <h3>Additional Comments</h3>
      <textarea 
        v-model="comments"
        placeholder="Enter additional details about the loss reason..."
        rows="4"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WinOrLoss',
  data() {
    return {
      status: null,
      comments: ''
    }
  },
  computed: {
    isValidForSubmit() {
      return this.status !== null;
    }
  },
  watch: {
    isValidForSubmit: {
      handler(newValue) {
        this.$emit('isValidForSubmit', newValue);
      },
      immediate: true,
    },
  },
  methods: {
    setStatus(newStatus) {
      this.status = newStatus;
    },
    handleLookup() {
      // Implement lookup functionality
    }
  }
}
</script>

<style scoped>
.win-or-lost {
  padding: 20px;
  font-family: 'Segoe UI', sans-serif;
}

.description {
  color: #333;
  margin-bottom: 20px;
  line-height: 1.5;
}

.lookup-link {
  margin-bottom: 20px;
}

.lookup-link a {
  color: #0078D4;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.lookup-link a:hover {
  text-decoration: underline;
}

.status-section h3,
.comments-section h3 {
  font-size: 16px;
  margin-bottom: 12px;
  color: #333;
}

.status-buttons {
  display: flex;
  gap: 12px;
}

.status-btn {
  flex: 1;
  padding: 20px;
  border: 1px solid #E1E1E1;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.status-btn:hover {
  background-color: #F3F3F3;
}

.status-btn.active {
  background-color: #EAF6FF;
  border-color: #0078D4;
}

.status-btn i {
  font-size: 24px;
}

.status-btn.active:first-child i {
  color: #107C10;
}

.status-btn.active:last-child i {
  color: #D83B01;
}

textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #E1E1E1;
  border-radius: 4px;
  resize: vertical;
  font-family: inherit;
}

textarea:focus {
  outline: none;
  border-color: #0078D4;
}
</style>
